import { Flex } from "@chakra-ui/react";
import { ResponsiveBar } from "@nivo/bar";
import { numberFormatter } from "../../../../../../utils";
import React from "react";
import { CustomBar } from "../../../../../../components";

function ByDimensionChart({ data, handleBarClick }) {
  const CHART_COLORS = Object.freeze({
    "Scope 1": "hsla(50,100%,50%,0.49)",
    "Scope 2": "hsla(0,100%,50%,0.62)",
    "Scope 3": "hsla(212,100%,50%,0.75)",
    "Low value *": "hsl(183,11%,67%)",
  });

  return <Flex display={"block"} height={600} width={"100%"}>
    <ResponsiveBar
      data={data}
      keys={["Low value *", "Scope 3", "Scope 2", "Scope 1"]}
      indexBy="name"
      margin={{ top: 30, right: 150, bottom: 150, left: 65 }}
      padding={0.3}
      groupMode="stacked"
      valueScale={{ type: "linear" }}
      indexScale={{ type: "band", round: true }}
      colors={item => CHART_COLORS[item.id]}
      borderColor={{
        from: "color",
        modifiers: [
          [
            "darker",
            1.6
          ]
        ]
      }}
      barComponent={(barProps) => {
        const barItemData = {
          x: barProps.bar.x,
          y: barProps.bar.y,
          width: barProps.bar.width,
          height: barProps.bar.height,
          data: barProps.bar.data
        };
        return (
          <CustomBar barItemData={barItemData} dataAttribute={"name"} handleBarClick={handleBarClick} />
        );
      }}
      axisTop={null}
      axisRight={null}
      axisBottom={{
        tickSize: 0,
        tickPadding: 20,
        legendPosition: "middle",
        legendOffset: 40,
        tickRotation: -45
      }}
      axisLeft={{
        tickSize: 5,
        tickPadding: 5,
        tickRotation: 0,
        legendPosition: "middle",
        legend: "Tonnes of CO2e",
        legendOffset: -50,
        format: value => numberFormatter(value, 2)
      }}
      legends={[
        {
          dataFrom: "keys",
          anchor: "top-right",
          direction: "column",
          justify: false,
          translateX: 60,
          translateY: 50,
          itemsSpacing: 10,
          itemWidth: 50,
          itemHeight: 40,
          itemDirection: "left-to-right",
          itemOpacity: 0.85,
          symbolShape: "circle",
          symbolSize: 20
        }
      ]}
    />
  </Flex>;
}

export default ByDimensionChart;
